export const LOAN_CONFIG = {
    HANDLING_CHARGE_RATE: 0.0035,
};




export const getBalanceMappings = (isPioneer) => [
    { code: "03010101", title: "Share Capital", type: "savings", iconClass: "bi bi-piggy-bank" },
    { code: "02020305", title: "Ordinary Savings", type: "savings", iconClass: "bi bi-share" },
    { code: "02010401", title: "Education Savings", type: "savings", iconClass: "bi bi-mortarboard" },
    { code: "02010402", title: "Christmas Savings", type: "savings", iconClass: "bi bi-gift" },
    { code: "02020301", title: "Retirement Savings", type: "savings", iconClass: "bi bi-piggy-bank" },
    { code: isPioneer ? "01020318" : "01020310", title: "Car Loan", type: "loan", iconClass: "bi bi-car-front" },
    { code: isPioneer ? "01020313" : "01020306", title: "1 year Normal Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
    { code: isPioneer ? "01020315" : "01020314", title: "2 year Normal Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
    { code: isPioneer ? "01020316" : "01020308", title: "Housing Loan", type: "loan", iconClass: "bi bi-house" },
    { code: isPioneer ? "01020317" : "01020309", title: "Land Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
    { code: isPioneer ? "01020319" : "01020311", title: "Motorcycle Loan", type: "loan", iconClass: "bi bi-bicycle" },
    { code: isPioneer ? "01020320" : "01020312", title: "Tricycle Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
    { code: isPioneer ? "01020325" : "01020307", title: "Emergency Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
    { code: isPioneer ? "01020321" : "01020301", title: "Commodity Loan", type: "loan", iconClass: "bi bi-shop-window" },
    { code: isPioneer ? "01020322" : "01020304", title: "Electronic Purchase Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
    { code: isPioneer ? "01020324" : "01020303", title: "Office Equipment Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
    { code: isPioneer ? "01020323" : "01020302", title: "Stationary Purchase Loan", type: "loan", iconClass: "bi bi-currency-dollar" },
    { code: "03010111", title: "Sweat Equity", type: "savings", iconClass: "bi bi-currency-dollar" },
    { code: "03010112", title: "UNN Shares", type: "savings", iconClass: "bi bi-currency-dollar" },
    { code: "02010405", title: "Land Development Savings", type: "savings", iconClass: "bi bi-currency-dollar" },
    { code: "02020306", title: "SPECIAL DEPOSIT", type: "savings", iconClass: "bi bi-currency-dollar" },
    { code: "02010322", title: "Life Assurance Claim", type: "claim", iconClass: "bi bi-shield-check" }
];

// Helper functions
export const getBalanceValue = (balance, code) => {
    const item = balance?.summary?.find(item => item.itemId.trim() === code);
    return item ? parseFloat(item.Balance) || 0 : 0;
};

export const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-NG', {
        style: 'currency',
        currency: 'NGN',
        minimumFractionDigits: 2
    }).format(amount);
};
